import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@mui/system';
import MuiBox from '@mui/material/Box';
import Property from './Property.js';

const PropertyContainer = styled(MuiBox) `
  display: flex;
  align-items: center;
  ${({ theme }) => `
    svg {
      margin-right: ${theme.spacing(2.49)};
    }
  `}
`;
const IconProperty = (_a) => {
    var { value, label, icon } = _a, rest = __rest(_a, ["value", "label", "icon"]);
    return (jsx(Property, Object.assign({ "data-test-id": "icon-property", label: label }, rest, { children: jsxs(PropertyContainer, { children: [icon, " ", value] }) })));
};

export { IconProperty as default };
//# sourceMappingURL=IconProperty.js.map
